(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('FirstName', FirstName);

    FirstName.$inject = ['$resource'];

    function FirstName ($resource) {
        var resourceUrl =  'api/first-names/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
